module.exports = __webpack_public_path__ + "static/img/图层 14.85656547.png";